export const NATIVE_SOL_ADDRESS = '11111111111111111111111111111111';
